import React, { useState } from 'react';
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
    Box,
  CircularProgress,
  Alert
} from '@mui/material';
import userApi from '../../api/userApi';
const extractErrorMessage = (error) => {
  if (!error) return 'Errore sconosciuto';
  if (error.response?.data) return JSON.stringify(error.response?.data);
  if (!error.response) {
    return "L'elaborazione richiede più tempo del previsto. Riprova.";
  }
  return error.message || JSON.stringify(error);
};
export default function ForgotPasswordPage() {

  const [username, setUsername] = useState('');
  const [done, setDone] = useState(false);
  const [err, setErr] = useState(null);
  const [executing, setExecuting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(null);

    try {
      setExecuting(true);
      await userApi.forgotPassword(username);
      setDone(true);
    } catch (e) {
      setErr(extractErrorMessage(e));
    } finally {
      setExecuting(false);
    }
  };

  return (
    <Container maxWidth="xs" sx={{ mt: 10 }}>
      <Paper sx={{ p: 4 }}>
        <Typography variant="h5" gutterBottom>
          Recupero password
        </Typography>
      {executing && (
        <Box
          sx={{
            position: 'absolute',
            top: 0, left: 0, right: 0, bottom: 0,
            bgcolor: 'rgba(255,255,255,0.7)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 10,
          }}
        >
          <CircularProgress />
        </Box>
      )}
        {done ? (
          <Alert severity="success">
            Se l'email è registrata riceverai un messaggio
          </Alert>
        ) : (
          <form onSubmit={submit}>
            {err && <Alert severity="error">{err}</Alert>}

            <TextField
              fullWidth
              label="Username"
              type="username"
              sx={{ mt: 2 }}
              value={username}
              onChange={e => setUsername(e.target.value)}
              required
            />

            <Button
              fullWidth
              type="submit"
              variant="contained"
              sx={{ mt: 2 }}
            >
              Invia
            </Button>
          </form>
        )}
      </Paper>
    </Container>
  );
}